package diana.soleil.design.iraniancanadienbazzar.core.designsystem.component

import diana.soleil.design.iraniancanadienbazzar.core.designsystem.resources.Res
import diana.soleil.design.iraniancanadienbazzar.core.designsystem.resources.gem_danestaniha
import diana.soleil.design.iraniancanadienbazzar.core.designsystem.resources.gem_jokes
import diana.soleil.design.iraniancanadienbazzar.core.designsystem.resources.gem_poetry
import diana.soleil.design.iraniancanadienbazzar.core.designsystem.resources.gem_recipes
import diana.soleil.design.iraniancanadienbazzar.core.designsystem.resources.gem_shahnameh
import diana.soleil.design.iraniancanadienbazzar.core.designsystem.resources.gem_soon
import diana.soleil.design.iraniancanadienbazzar.core.designsystem.resources.gem_stories
import org.jetbrains.compose.resources.DrawableResource

/**
 * Illustrated cover art for the Hidden Gems hub section cards — same **Fluent Emoji 3D** style as
 * the business category icons ([categoryImageRes]), so the two surfaces read as one system. PNG
 * bitmaps (192px) render identically on every target incl. the Kotlin/JS Skiko canvas (no reliance
 * on a system color-emoji font). Swapping art is a 1:1 file replacement in `drawable/gem_*.png`.
 */
enum class GemArt {
    Jokes,
    Recipes,
    Danestaniha,
    Shahnameh,
    /** The hub itself — Home's Explore button into Hidden Gems. Sparkles, shared with [ComingSoon]. */
    Hub,
    /** Persian poetry — the quill (Fluent "Feather"). */
    Poetry,
    /** Regional short stories — the open book (Fluent "Open book"). */
    Stories,
    ComingSoon,
}

fun gemArtImage(art: GemArt): DrawableResource = when (art) {
    GemArt.Jokes -> Res.drawable.gem_jokes
    GemArt.Recipes -> Res.drawable.gem_recipes
    GemArt.Danestaniha -> Res.drawable.gem_danestaniha
    GemArt.Shahnameh -> Res.drawable.gem_shahnameh
    // Same sparkles bitmap as ComingSoon today; kept as its own case so the Home entry can get its
    // own art without touching call sites.
    GemArt.Hub -> Res.drawable.gem_soon
    GemArt.Poetry -> Res.drawable.gem_poetry
    GemArt.Stories -> Res.drawable.gem_stories
    GemArt.ComingSoon -> Res.drawable.gem_soon
}
